export default __webpack_public_path__ + "static/media/logo.d173b391.png";